import { render } from "./DTableHeading.vue?vue&type=template&id=1c9e0a26"
import script from "./DTableHeading.vue?vue&type=script&lang=js"
export * from "./DTableHeading.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__